import {
  readPlaygroundUid,
  readPlaygroundResetUid,
  rememberPlaygroundUid,
} from "../lib/playground-uid";
import { startPlaygroundSession } from "../api/start-playground-session";

/** 挂件连接同一测试身份需要的令牌。 */
export interface PlaygroundToken {
  socketUrl: string;
  token: string;
  capabilities: { support_requests: boolean };
}

/** 有效身份续期保留对话；服务端已清理旧身份时通知页面挂载新匿名测试。 */
export async function renewPlaygroundToken(
  uid: string,
  onReplaced?: () => void,
): Promise<PlaygroundToken | null> {
  const result = await startPlaygroundSession({ uid });
  return result.match(
    (session) => {
      // New test 或其他续期已切换身份时，迟到响应不能改写新测试。
      const currentUid = readPlaygroundUid();
      if (
        readPlaygroundResetUid() ||
        (currentUid !== undefined && currentUid !== uid)
      )
        return null;
      if (session.uid !== uid) {
        rememberPlaygroundUid(session.uid);
        onReplaced?.();
        return null;
      }
      return {
        socketUrl: session.socket_server_url,
        token: session.token,
        capabilities: session.capabilities,
      };
    },
    () => null,
  );
}
